import { getEnjoyList, getPersionalViewVideoTj } from '@/api/explain'
const obj = {
  allExplains: [],
  hasEnjoyList: [],
  hasViewExplainRight: false,
  hasViewVideoExplain: false
}
export default {
  namespaced: true,
  state: JSON.parse(JSON.stringify(obj)),
  mutations: {
    setallExplains(state, { data }) {
      state.allExplains = data
    },
    setHasEnjoyList(state, payload) {
      state.hasEnjoyList = payload
    },
    setHasViewExplainRight(state, payload) {
      state.hasViewExplainRight = payload
    },
    setHasViewVideoExplain(state, payload) {
      state.hasViewVideoExplain = payload
    },
    setExplainNum(state, payload) {
      const { explainId, type } = payload
      const { allExplains } = state
      const index = allExplains.findIndex((i) => i.id === explainId)
      if (index > -1) {
        const item = allExplains[index]
        item[type] = Number(item[type]) + 1
      }
      state.allExplains = allExplains
    },
    clearStore(state) {
      Object.keys(obj).forEach((key) => {
        state[key] = obj[key]
      })
    }
  },
  actions: {
    async getEnjoyList({ state, rootState, commit }, payload) {
      const { explains } = payload
      const explainsData = explains || state.allExplains
      const {
        user: { openid }
      } = rootState
      return getEnjoyList({ openid }).then((res) => {
        const allEnjoyData = res.data.data
        const hasEnjoyList = allEnjoyData.filter((i) =>
          explainsData.find((z) => z.id === i.explainId)
        )
        commit('setHasEnjoyList', hasEnjoyList)
        return hasEnjoyList
      })
    },
    async getHasViewVideoExplain({ commit }, { questionId }) {
      const res = await getPersionalViewVideoTj([questionId])
        .then((res) => {
          return Number(res.data.data) > 0
        })
        .catch((e) => {
          return false
        })
      commit('setHasViewVideoExplain', res)
    }
  }
}
